import React from "react";
import { Box } from "@material-ui/core";

import Dashboard from "../modules/Dashboard";

export const DashboardPage = () => {
  return <Box py={2} style={{backgroundColor: "white", height: "100%"}}>
    <Dashboard />
  </Box>;
};
